var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftBar" },
    [
      _c("v-drawer", { attrs: { direction: "left", width: "26%" } }, [
        _c(
          "div",
          { staticClass: "animated fadeInLeftBig dx" },
          [
            _c(
              "bar-card",
              { staticClass: "lefts lefts1", attrs: { bg: "border-new" } },
              [
                _c("g-title", { attrs: { bg: "pp" } }, [_vm._v("产业概况")]),
                _c("div", { staticClass: "panelContent" }, [_c("left-mid")], 1),
              ],
              1
            ),
            _c(
              "bar-card",
              { staticClass: "lefts lefts2", attrs: { bg: "border-new" } },
              [
                _c("g-title", { attrs: { bg: "green" } }, [_vm._v("数字农村")]),
                _c("div", { staticClass: "panelContent" }, [_c("nycz-bh")], 1),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }